module.exports = __webpack_public_path__ + "static/media/12x12-5.ca2c687e.png";